import Hero from '../Hero'
import ValuePropositions from 'components/ckan/ValuePropositions.jsx'
import Features from 'components/ckan/Features.jsx'
import Contact from 'components/ckan/Contact.jsx'
import Contact2 from 'components/ckan/Contact2.jsx'
import Faq from 'components/ckan/support/Faq.jsx'

export default function Index() { 
  const featured = [
  {
    title: "Walkthroughs",
    text: "Our CKAN experts will take you through any aspect of CKAN step-by-step, over video or call.",
    icon: "/assets/icons/footprint.json",
  },
    {
    title: "Troubleshooting",
    text: "Not sure what’s causing your problem? We are quick to identify, analyze and solve issues.",
    icon: "/assets/icons/repair-tools.json",
  },
  {
    title: "Remote Desktop Support",
    text: "Wherever you are in the world, we’ll take a close look at your instances and make fixes directly.",
    icon: "/assets/icons/tech-support-2.json",
  },
  {
    title: "Literature",
    text: "We can point you towards our expert articles covering various CKAN topics and approaches.",
    icon: "/assets/icons/ebook.json",
  },
  {
    title: "Workarounds",
    text: "Being slowed down by a blocker? We’ll help you to navigate around it.",
    icon: "/assets/icons/seminar.json",
  },
      {
    title: "Third-Party Integration Support",
    text: "Problems with integration? Our experts can provide support and assistance.",
    icon: "/assets/icons/hexagonal.json",
  },
      {
    title: "Customized SLA",
    text: "We can provide customized service level agreements (SLAs) to match your specific requirements and ensure your CKAN instance is always available.",
    icon: "/assets/icons/verified-2.json",
  },
    {
    title: "Regular Maintenance",
    text: "We provide regular maintenance to ensure your CKAN instance is up-to-date and running smoothly, reducing downtime and improving performance.",
    icon: "/assets/icons/settings.json",
  },
] 

const values= [
  {
    title: "Best in class",
    text: "As the creators and stewards of CKAN, we’ve been providing insider expertise for longer than anyone else.",
  },
    {
    title: "Available on demand",
    text: "Contact us when you need us for on-the-spot support.",
  },
    {
    title: "Worldwide coverage",
    text: "With CKAN experts distributed across the globe, you can get support across all timezones.",
  },
]

const numbers = [
  {
    number: "1000+",
    title: "Projects completed",
  },
    {
    number: "15M+",
    title: "Datasets",
  },
    {
    number: "$5m+",
    title: "APR",
  },
    {
    number: "99.99%",
    title: "Guaranteed uptime",
  },
]
  return (
    <div className="flex flex-wrap justify-center">
      <div className="max-w-7xl w-full">
        <Hero 
        topTitle="CKAN Support"
        title="CKAN expertise on demand. From the team that built it."
        subtitle="Fast and reliable CKAN support from those who know it best. Contact our global team around the clock."
        ctaOffer="See other CKAN services"
        ctaUrl="/solutions/ckan#services"/>
        <ValuePropositions topTitle="Your solution for any challenge" title="Don’t get stuck when things go wrong – our team is always here to help." valuePropositions={values}/>
      </div>
      <Features topTitle="Keep your CKAN running smoothly" title="We provide customized CKAN support packages that fit your specific needs. Our dedicated team of experts offers troubleshooting, walkthroughs, and remote desktop support to keep your CKAN instances running smoothly." featuredItems={featured}/>
      <div className="max-w-7xl w-full">
        <Faq />
      </div>
        <Contact />
        <div className="md:hidden">
          <Contact2 />
        </div>
    </div>
  )
}